import { render, staticRenderFns } from "./tarif-actes.html?vue&type=template&id=0f9dbcb4&scoped=true&external"
import script from "./tarif-actes.js?vue&type=script&lang=js&external"
export * from "./tarif-actes.js?vue&type=script&lang=js&external"
import style0 from "./tarif-actes.scss?vue&type=style&index=0&id=0f9dbcb4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9dbcb4",
  null
  
)

export default component.exports